import {IItem} from '../../types/IItem';

export function getFeatureString(item: IItem) {
  return `${item?.features?.load_index ?? ''} ${item?.features?.speed_rating ?? ''} ${item?.features?.load_range ?? ''}`
}

export function getFeatures(item: IItem) {
  return Object.entries(item.features).map((item: any) => {
    let value = item[1] ?? '-';

    if(!value.length) value = '-';

    return {name: item[0].replace('_', ' '), value: value};
  });
}

export function weightedCost(item: IItem): number {
  const totalQty = item.sourcing.reduce((sum, g) => sum + g.selected_quantity, 0);
  return +(item.sourcing.reduce((sum, g) => sum + g.selected_quantity * g.cost, 0) / totalQty).toFixed(2);
}

export function weightedPrice(item: IItem): number {
  const sourcing = item.sourcing ?? [];
  const totalQty = sourcing.reduce((sum, s) => sum + (s.selected_quantity || 0), 0);
  if (totalQty === 0) return 0;
  return +(sourcing.reduce((sum, s) => sum + (s.selected_quantity || 0) * (s.price || 0), 0) / totalQty).toFixed(2);
}

export function totalQuantity() {

}
